import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

export const useIsDesktopView = () => {
  const theme = useTheme();
  const isDesktopView = useMediaQuery(theme.breakpoints.down('xl'));
  return isDesktopView;
};
